<div class="mainpage-videos-container">
  <app-video-grid
    [title]="'Featured Videos'"
    [videos$]="featuredVideos$"
    [type]="'card'"
    [me]="me"
  ></app-video-grid>
</div>
